import { render, staticRenderFns } from "./newsDetailed.vue?vue&type=template&id=de96acd0&scoped=true&"
import script from "./newsDetailed.vue?vue&type=script&lang=js&"
export * from "./newsDetailed.vue?vue&type=script&lang=js&"
import style0 from "./newsDetailed.vue?vue&type=style&index=0&id=de96acd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de96acd0",
  null
  
)

export default component.exports